import {useEffect, useRef, useState} from "react";
import PortfolioImage from "../Portfolios/Entities/PortfolioImage";
import Portfolio from "../Portfolios/Entities/Portfolio";
import {useMobile} from "../Context/MobileContext";
import {usePreloadImages} from "../Hooks/usePreloadImages";
import {useWindowWidth} from "../Context/WindowWidthContext";

function PortfolioDisplay({piece, portfolio}: { piece: PortfolioImage, portfolio?: Portfolio }) {
    const {isMobile} = useMobile();
    const windowWidth = useWindowWidth();

    // Preload all images in this portfolio
    usePreloadImages(portfolio);

    const getTargetSize = (img: PortfolioImage) => {
        if (isMobile && img.pixelWidth > windowWidth) {
            const ratio = img.pixelHeight / img.pixelWidth;
            return {width: windowWidth, height: Math.round(windowWidth * ratio)};
        }
        return {width: img.pixelWidth, height: img.pixelHeight};
    };

    // Animate wrapper to new dimensions when piece changes
    const [wrapperSize, setWrapperSize] = useState(() => getTargetSize(piece));
    const prevPieceRef = useRef(piece);
    useEffect(() => {
        if (prevPieceRef.current !== piece) {
            prevPieceRef.current = piece;
        }
        setWrapperSize(getTargetSize(piece));
    }, [piece, isMobile, windowWidth]);

    const minHeight = (isMobile && portfolio)
        ? Math.max(...portfolio.pieces.map(p => {
            if (p.pixelWidth > windowWidth) {
                return Math.round(windowWidth * (p.pixelHeight / p.pixelWidth));
            }
            return p.pixelHeight;
        }))
        : undefined;

    const caption = (
        <div className="caption" style={{order: isMobile ? 2 : 1, marginTop: isMobile ? "20px" : "0"}}>
            <p className="item-title">{piece.title}</p>
            <p className="item-size">{piece.size}</p>
        </div>
    );

    return (
        <div id="portfolio">
            <div
                id="portfolio-wrapper"
                className="panel" style={{
                display: "flex",
                flexWrap: isMobile ? "wrap" : "nowrap",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "center" : "flex-start",
                justifyContent: isMobile ? "center" : "flex-start",
            }}>
                {!isMobile && caption}
                <div
                    className="portfolio-image-wrapper"
                    style={{
                        order: isMobile ? 1 : 2,
                        minHeight: isMobile ? minHeight : undefined,
                        ...(isMobile ? {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end"
                        } : {})
                    }}
                >
                    <div
                        id="portfolio-animating-box"
                        style={{
                            width: wrapperSize.width,
                            height: wrapperSize.height,
                            transition: "width 0.4s ease, height 0.4s ease",
                            overflow: "hidden"
                        }}
                    >
                        <img
                            id="portfolio-image"
                            src={"/images/" + piece.image} alt="refuge" className="item" style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block"
                        }}/>
                    </div>
                </div>
                {isMobile && caption}
            </div>
        </div>
    );
}

export default PortfolioDisplay;